import React from "react";
import clsx from "clsx";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";
import on from "../../assets/on2@2x.png";
import off from "../../assets/off2@2x.png";
import notice from "../../assets/06IconIi@2x.png";
import rightArrowGray from "../../assets/07ElementsSize2RightGray@2x.png";
import leftArrowBlack from "../../assets/leftArrow@2x.png";

interface Props {
   checked: boolean;
   setChecked: (checked: boolean) => void;
   goTo: (e: any, url: string) => void;
   goBack: () => void;
   onClick: () => void;
}

const UnderageAgrContent10602: React.FC<Props> = ({
   checked,
   setChecked,
   goTo,
   goBack,
   onClick,
}) => {
   const classes = useStyles();
   return (
      <>
         <div className={clsx(classes.container)}>
            <div>
               <div className={classes.goBackArea}>
                  <img src={leftArrowBlack} onClick={goBack} />
               </div>
               <h1 className={classes.h1}>
                  만 14세 미만은 보호자의 <br />
                  동의가 필요합니다.
               </h1>
               <div className={classes.agr}>
                  <div
                     className={classes.checkboxAll}
                     onClick={(e) => {
                        e.preventDefault();
                        setChecked(!checked);
                     }}
                  >
                     <div
                        className={classes.flex}
                        style={{
                           paddingRight: 24,
                        }}
                     >
                        <input
                           className={clsx(
                              classes.checkbox,
                              checked && "checked"
                           )}
                           id="agreement2"
                           type="checkbox"
                           checked={checked}
                        />
                        <label htmlFor="agreement2"></label>
                        <span className={clsx(classes.checkbox__text)}>
                           모두 동의합니다.
                        </span>
                     </div>
                  </div>
               </div>
               <ul className={classes.agrList}>
                  <li onClick={(e) => goTo(e, "agr/tos/2")}>
                     <div className={classes.flex}>
                        <span>보호자 개인정보 수집 및 이용에 동의합니다.</span>
                     </div>
                     <span className={classes.view_more}></span>
                  </li>
                  <li onClick={(e) => goTo(e, "agr/tos/9")}>
                     <div className={classes.flex}>
                        고유식별정보 처리를 동의합니다.
                     </div>
                     <span className={classes.view_more}></span>
                  </li>
               </ul>
            </div>
            <div className={classes.caption}>
               <ul>
                  <li className={classes.tag}>
                     보호자의 휴대폰 본인확인은{" "}
                     <span>보호자의 휴대폰 번호</span>로 진행해야 합니다. 휴대폰
                     본인확인은, 통신사 선택 후 <span>문자로 인증하기</span>를
                     선택하여 진행해 주세요.
                  </li>
                  <li className={classes.tag}>
                     보호자는 14세 미만의 아동과 20세 이상 차이가 나야 합니다.
                  </li>
                  <li className={classes.tag}>
                     보호자 동의 과정 중에 수집된 개인 정보는 확인 후 즉시
                     파기하며 저장되지 않습니다.
                  </li>
               </ul>
            </div>
         </div>
         <div className={classes.float}>
            <button
               // ref={btnRef as RefObject<HTMLButtonElement>}
               disabled={!checked}
               className={classes.button}
               onClick={onClick}
            >
               휴대폰 본인확인을 시작합니다
            </button>
         </div>
      </>
   );
};

const useStyles = createUseStyles((theme: ThemeType) => ({
   container: {
      display: "flex",
      flexDirection: "column",
      width: " 100vw",
      height: "100vh",
      paddingBottom: "7.4rem",
      overflow: "auto",
      justifyContent: "space-between",
   },
   desc: {
      borderRadius: "50%",
      width: "6rem",
      height: "6rem",
      boxShadow: "0px 3px 16px 0px rgba(0, 0, 0, 0.08)",
      padding: 10,
      margin: "0px 0px 10px 20px",
      "& > img": {
         width: "4rem",
         height: "4rem",
      },
   },
   h1: {
      ...theme.t1,
      letterSpacing: "-0.05rem",
      color: theme.mono0,
      margin: "0px 20px",
      marginBottom: 30,
      fontWeight: theme.demiLight,
   },
   checkboxAll: {
      wordBreak: "keep-all",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: theme.mono100,
      padding: "22px 16px",
      boxShadow: "0px 3px 16px 0px rgba(0,0,0,0.08)",
      borderRadius: 10,
      boxSizing: "border-box",
   },
   checkbox: {
      display: "none",
      "& + label": {
         width: "22px",
         paddingLeft: 16,
         marginRight: 10,
         background: `url(${off}) center center no-repeat`,
         backgroundSize: "22px 22px",
         verticalAlign: "baseline",
      },
      "&.checked + label": {
         background: `url(${on}) center center no-repeat`,
         backgroundSize: "22px 22px",
      },
   },
   checkbox__text: {
      ...theme.text,
      lienHeight: "2.6rem",
      paddingTop: 2,
      fontWeight: theme.demiLight,
      "&:after": {
         content: "' [필수]'",
         fontWeight: theme.medium,
         color: theme.primaryTxt,
      },
   },
   flex: {
      display: "flex",
   },
   float: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      padding: 20,
      backgroundColor: "#FFF",
   },
   button: {
      width: "100%",
      fontSize: "1.8rem",
      background: theme.primarySol,
      height: 54,
      color: theme.mono100,
      padding: "13px 20px",
      fontWeight: theme.medium,
      borderRadius: 6,

      "&:disabled": {
         background: theme.monoDisabled,
         color: theme.mono50,
      },
   },

   goBackArea: {
      height: "60px",
      padding: "19px 20px 9px 20px",
      marginBottom: "30px",
      "& > img": {
         width: "22px",
         filter: "none",
         display: "inline-block",
      },
   },
   agr: {
      width: "100%",
      padding: "0px 20px",
   },
   caption: {
      backgroundColor: theme.monoBg,
      padding: 20,
      marginBottom: 20,
      "& > ul": {
         listStyle: "none",
         padding: 0,
         margin: 0,
         "& > li": {
            ...theme.sText,
            marginBottom: "12px",
            "& > span": {
               color: theme.primaryTxt,
               fontWeight: theme.bold,
            },
            "&:before": {
               position: "absolute",
               left: 0,
               content: "'·'",
            },
            "&:last-of-type": {
               marginBottom: 0,
            },
         },
      },
   },
   agrList: {
      padding: "8px 20px 20px 20px !important",
      "& li": {
         ...theme.sText,
         position: "relative",
         paddingLeft: 14,
         marginBottom: 12,
         margin: "20px 8px 0 0",
         display: "flex",
         justifyContent: "space-between",
         color: theme.mono50,
         "&:last-of-type": {
            marginBottom: 0,
         },
      },
   },
   view_more: {
      width: 24,
      height: 24,
      background: `url(${rightArrowGray}) right center no-repeat`,
      backgroundSize: "24px auto",
   },
   tag: {
      ...theme.sText,
      color: theme.mono50,
      lineHeight: "2.5rem",
      paddingLeft: "25px!important",
      background: `url(${notice}) left 0px top 5px no-repeat`,
      backgroundSize: "16px 16px",
   },
}));
export default UnderageAgrContent10602;
